export const planningEventsSettings = {
  eventClickActive: {
    admin: {
      month: true,
      week: true,
      day: true
    }
  },
  cellDoubleClickActive: {
    admin: {
      month: false,
      week: true,
      day: true
    }
  },
  cellDragActive: {
    admin: {
      month: false,
      week: true,
      day: true
    }
  },
  showAvailabilitySplit: {
    admin: {
      month: false,
      week: false,
      day: false
    }
  }
}
